import "./i18n"

import * as serviceWorker from "./serviceWorker"

import App from "./App"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import React from "react"
import ReactDOM from "react-dom"
import store from "./store"

const app = (
  <Provider store={store}>
    <BrowserRouter>
       <App />
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
